import { useMemo } from 'react';
import { useCurrentView } from './useCurrentView';
import { useGeneratedCachedViewById } from './useGeneratedCachedViewById';
export const useIsCurrentViewModified = () => {
  const view = useCurrentView();
  const cachedView = useGeneratedCachedViewById(view && view.id);
  return useMemo(() => !view || !cachedView || JSON.stringify(view) !== JSON.stringify(cachedView), [cachedView, view]);
};